import "@/App.css";
import { Toaster } from "sonner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";

function App() {
  return (
    <div className="App grain relative min-h-screen bg-[#050505] text-white">
      <SmoothScroll />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster theme="dark" position="bottom-center" richColors />
    </div>
  );
}

export default App;
